<template>
  <div class="admin-new-order-builder-meta-item">
    <transition name="slide-x-transition" mode="out-in">
      <v-row dense align="baseline" justify="space-between">
        <v-col cols="4">
          <AdminFieldRelated
            placeholder="Select an Item"
            :Model="CartItemModel"
            :item="item"
            :header="itemHeader"
            :dense-select="false"
            :init-focused="true"
            sort-key="name"
            @update:object="
              $emit('update', {
                item_id: $event.id,
                custom_price: $event.price,
                item_name: $event.name,
                item: $event,
              })
            "
          />
        </v-col>

        <v-col cols="2">
          <v-text-field
            :value="price_in_usd"
            type="number"
            min="0"
            prefix="$"
            dense
            hide-details
            outlined
            @input="$emit('update', { custom_price: $event * 100 })"
          />
        </v-col>
        <v-col cols="2">
          <v-text-field
            :value="quantity"
            type="number"
            min="1"
            dense
            hide-details
            outlined
            @input="$emit('update', { quantity: $event })"
          />
        </v-col>
        <v-col cols="2" class="text-center">{{
          formatUSD(item.price * item.quantity)
        }}</v-col>
        <v-col cols="auto">
          <BtnRemove @remove="$emit('remove')" />
        </v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import formatUSD from '@/utils/formatUSD'
import ItemModel from '@/models/ItemModel'
import CartItemModel from '@/models/CartItemModel'
import FieldTypes from '@/constants/FieldTypes'

import BtnRemove from '@/components/BtnRemove'
import AdminFieldRelated from '@/components/AdminFieldRelated'

import _get from 'lodash/get'
export default {
  name: 'AdminNewOrderBuilderLineItem',
  components: {
    AdminFieldRelated,
    BtnRemove,
  },
  props: {
    item: {
      type: CartItemModel,
      default: () => new CartItemModel(),
    },
  },
  data() {
    return {
      CartItemModel,
      itemHeader: {
        text: 'Item',
        value: 'item.name',
        type: FieldTypes.BELONGS_TO,
        foreignModel: ItemModel,
        align: 'start',
        width: 200,
      },
    }
  },
  computed: {
    price_in_usd() {
      return this.item.price / 100
    },
    quantity() {
      return this.item.quantity
    },
    theItem() {
      if (!_get(this.item, 'item_id')) return
      return ItemModel.find(this.item.item_id)
    },
  },
  methods: {
    formatUSD,
    add() {
      this.$emit('add')
    },
  },
}
</script>
